import { ArrowUpRight } from "lucide-react";
import { Overline, Reveal } from "./Reveal";
import { SERVICES, waLink } from "../../lib/site";

const ServiceCard = ({ service, index }) => (
    <Reveal delay={(index % 3) * 0.12} className="h-full">
        <article
            data-testid={`service-card-${service.slug}`}
            className="group flex h-full flex-col border border-gold/15 bg-emerald-900/30 transition-colors duration-500 hover:border-gold/45"
        >
            <div className="relative h-64 overflow-hidden md:h-72">
                <img
                    src={service.image}
                    alt={service.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/70 via-transparent to-transparent" />
                <span className="absolute left-5 top-5 font-serif text-sm italic tracking-widest text-gold-light/90">
                    {String(index + 1).padStart(2, "0")}
                </span>
            </div>
            <div className="flex flex-1 flex-col p-7 md:p-8">
                <h3 className="font-serif text-2xl tracking-wide text-cream md:text-[1.7rem]">
                    {service.name}
                </h3>
                <p className="mt-4 flex-1 text-sm font-light leading-relaxed tracking-wide text-sage/90">
                    {service.description}
                </p>
                <a
                    href={waLink(
                        `Hello Flammingo Luxurious Spa, I would like to enquire about the ${service.name}.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`service-enquire-${service.slug}`}
                    className="mt-7 inline-flex w-fit items-center gap-2 border-b border-gold/40 pb-1.5 text-[11px] font-medium uppercase tracking-[0.3em] text-gold transition-colors duration-300 hover:border-gold hover:text-gold-light"
                >
                    Enquire Now
                    <ArrowUpRight
                        size={14}
                        className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                    />
                </a>
            </div>
        </article>
    </Reveal>
);

const Services = () => (
    <section
        id="services"
        data-testid="services-section"
        className="relative py-28 md:py-36"
    >
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
                <div>
                    <Reveal>
                        <Overline>Signature Rituals</Overline>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-cream sm:text-5xl">
                            Our Signature{" "}
                            <span className="italic text-gold-light">
                                Experiences
                            </span>
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <p className="max-w-sm text-sm font-light leading-relaxed tracking-wide text-sage/80">
                        Seven considered rituals, each composed to slow the
                        senses and restore a feeling of calm.
                    </p>
                </Reveal>
            </div>

            <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {SERVICES.map((service, i) => (
                    <ServiceCard key={service.slug} service={service} index={i} />
                ))}
                <Reveal delay={0.24} className="hidden h-full lg:block">
                    <a
                        href={waLink(
                            "Hello Flammingo Luxurious Spa, I would like help choosing the right experience."
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="services-help-card"
                        className="group flex h-full flex-col items-start justify-between border border-gold/15 bg-gradient-to-br from-emerald-800/60 to-emerald-950 p-8 transition-colors duration-500 hover:border-gold/45"
                    >
                        <p className="font-serif text-2xl leading-snug tracking-wide text-cream md:text-[1.7rem]">
                            Unsure where{" "}
                            <span className="italic text-gold-light">
                                to begin?
                            </span>
                        </p>
                        <span className="mt-8 inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.3em] text-gold transition-colors duration-300 group-hover:text-gold-light">
                            Let us guide you
                            <ArrowUpRight
                                size={14}
                                className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                            />
                        </span>
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Services;
